import { GET_VLP_LEDGER } from "../../../Types";

const LoanVLPLedgerReducer = (state = [], action) => {
  switch (action.type) {
    case GET_VLP_LEDGER:
      return action.payload;
    default:
      return state;
  }
};
export default LoanVLPLedgerReducer;
